import React from 'react'
import { MySchoolPage } from '@plvs/rally/pages/app/MySchoolPage'
import { SchoolRenderControllerProvider } from '@plvs/respawn/renderController/school/SchoolRenderControllerProvider'

export const MySchoolPageContainer: React.FC = () => {
  return (
    <SchoolRenderControllerProvider>
      <MySchoolPage />
    </SchoolRenderControllerProvider>
  )
}
